import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';
import { UpdateCustomPaymentMethodForm } from '../../modules';

const UpdateCustomPaymentMethod = () => {
    const { params: { id } } = useRouteMatch();

    return (
        <EditScreenLayout isDesktopLarge path={routePaths.customPaymentMethodsSettings}>
            <UpdateCustomPaymentMethodForm customPaymentMethodId={id} />
        </EditScreenLayout>
    );
};


export default UpdateCustomPaymentMethod;
